/**
 * @generated SignedSource<<134add2a5f4b87673fb811bbe002d23e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProjectsPageDeleteProjectMutation$variables = {
  id: string;
};
export type ProjectsPageDeleteProjectMutation$data = {
  readonly deleteProject: boolean;
};
export type ProjectsPageDeleteProjectMutation = {
  response: ProjectsPageDeleteProjectMutation$data;
  variables: ProjectsPageDeleteProjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteProject",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectsPageDeleteProjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectsPageDeleteProjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f64a98d468909c6ffa949c669c97cb1",
    "id": null,
    "metadata": {},
    "name": "ProjectsPageDeleteProjectMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectsPageDeleteProjectMutation(\n  $id: ID!\n) {\n  deleteProject(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "89ce60fea655191755a03a5672609060";

export default node;
